import { type ReactNode } from 'react';
import clsx from 'clsx';

import { type Repub, REPUBS } from '@cx-modules/constants';

import styles from './styles/BetTypeLabels.module.css';

const Hot = () =>
<div className={clsx(styles.icon, styles.hot)}>
		<svg fill="none" height="24" width="16" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#a)">
				<path
        d="M10.66 21.901v.003a2.701 2.701 0 0 1-.664.905 8.623 8.623 0 0 1-1.464.219c-.052.004-.103.005-.154.008l-.04.002c-.016.002-.029 0-.044.002l-.113.002h-.025l-.166.003H7.93c-.051 0-.1 0-.15-.003h-.035a7.706 7.706 0 0 1-.435-.023h-.005a8.2 8.2 0 0 1-.874-.116c-.19-.173-.46-.45-.645-.756a1.759 1.759 0 0 1-.123-.238l-.003-.008c-.384-.841-.329-1.777.187-2.674.187-.325.411-.631.643-.927.617-.785 1.073-1.633 1.094-2.749.779.529 1.216 1.212 1.407 2.003.187.783.225 1.602.33 2.423.62-.313.777-.946.813-1.672a3.478 3.478 0 0 1 .526 3.596Z"
        fill="#FF425A" />

				<path
        d="M15.8 15.878c-.227 2.408-1.29 4.238-3.13 5.607l-.003.003-.011.01c-.436.322-.915.618-1.437.89.366-.318 1.04-.957 1.477-1.679a3.712 3.712 0 0 0 .25-.489c.766-1.682.658-3.55-.373-5.344-.373-.648-.822-1.262-1.285-1.851-1.234-1.569-2.144-3.264-2.185-5.492-1.557 1.057-2.43 2.422-2.81 4.002-.376 1.564-.451 3.199-.662 4.84-1.24-.627-1.553-1.888-1.623-3.34a6.953 6.953 0 0 0-1.051 7.185l.001.004c.633 1.357 1.523 2.018 1.975 2.283a5.64 5.64 0 0 1-.554-.263c-.04-.02-.081-.044-.121-.065-.192-.106-.37-.213-.52-.307-.033-.02-.064-.042-.096-.063a12.16 12.16 0 0 1-.251-.166l-.1-.072c-3.296-2.408-4.316-6.946-2.137-10.69.72-1.24 1.626-2.378 2.508-3.516 1.626-2.096 2.575-4.417 2.54-7.1C6.2.208 6.227.15 6.265 0c3.834 2.342 5.822 5.656 5.743 10.26.969-.537 1.35-1.343 1.582-2.44.239.431.412.727.566 1.032 1.116 2.21 1.877 4.517 1.642 7.026Z"
        fill="#FF425A" />

				<path
        d="m12.945 20.22-.006.015c-.066.16-.15.319-.243.474-.438.722-1.112 1.361-1.477 1.68-.1.053-.203.104-.306.155-.135.047-.268.09-.4.129h-.008c-.097.029-.194.056-.29.081h-.007c-.072.02-.143.037-.213.053a2.7 2.7 0 0 0 .664-.905V21.9a3.478 3.478 0 0 0-.525-3.596c-.036.726-.192 1.359-.812 1.672-.106-.822-.144-1.64-.331-2.423-.191-.791-.628-1.475-1.407-2.003-.02 1.115-.477 1.963-1.094 2.749a7.976 7.976 0 0 0-.643.927c-.516.896-.57 1.832-.187 2.674l.003.007c.033.08.075.16.123.238.185.307.455.584.645.757a7.379 7.379 0 0 1-.78-.189 2.795 2.795 0 0 1-.712-.203l-.001-.002-.006-.002c-.452-.265-1.342-.926-1.974-2.283l-.002-.004a6.953 6.953 0 0 1 1.052-7.185c.07 1.451.382 2.713 1.622 3.34.212-1.642.287-3.277.662-4.84.38-1.58 1.253-2.946 2.81-4.002.041 2.228.952 3.923 2.186 5.491.463.59.911 1.204 1.284 1.852 1.032 1.793 1.14 3.662.373 5.344v.001Z"
        fill="#FF425A" />

				<path
        d="m12.945 20.22-.006.015c-.066.16-.15.319-.243.474-.438.722-1.112 1.361-1.477 1.68-.1.053-.203.104-.306.155-.135.047-.268.09-.4.129h-.008c-.097.029-.194.056-.29.081h-.007c-.072.02-.143.037-.213.053a2.7 2.7 0 0 0 .664-.905V21.9a3.478 3.478 0 0 0-.525-3.596c-.036.726-.192 1.359-.812 1.672-.106-.822-.144-1.64-.331-2.423-.191-.791-.628-1.475-1.407-2.003-.02 1.115-.477 1.963-1.094 2.749a7.976 7.976 0 0 0-.643.927c-.516.896-.57 1.832-.187 2.674l.003.007c.033.08.075.16.123.238.185.307.455.584.645.757a7.379 7.379 0 0 1-.78-.189 2.795 2.795 0 0 1-.712-.203l-.001-.002-.006-.002c-.452-.265-1.342-.926-1.974-2.283l-.002-.004a6.953 6.953 0 0 1 1.052-7.185c.07 1.451.382 2.713 1.622 3.34.212-1.642.287-3.277.662-4.84.38-1.58 1.253-2.946 2.81-4.002.041 2.228.952 3.923 2.186 5.491.463.59.911 1.204 1.284 1.852 1.032 1.793 1.14 3.662.373 5.344v.001Z"
        fill="#E4FD69"
        opacity=".4" />

				<path
        d="m10.66 21.901-.001.003a2.702 2.702 0 0 1-.664.905 8.633 8.633 0 0 1-1.464.219c-.052.004-.103.005-.154.008l-.04.002-.044.001c-.032 0-.064.003-.096.004h-.042l-.167.003H7.93c-.051 0-.1 0-.15-.003h-.035a7.706 7.706 0 0 1-.435-.023c-.002.002-.004 0-.005 0a8.2 8.2 0 0 1-.874-.116c-.19-.173-.46-.45-.645-.756a1.759 1.759 0 0 1-.123-.238l-.003-.008c-.384-.841-.329-1.777.187-2.674.187-.324.411-.631.643-.927.617-.785 1.073-1.633 1.094-2.749.779.529 1.216 1.212 1.407 2.003.187.783.225 1.602.33 2.423.62-.313.777-.946.813-1.672a3.478 3.478 0 0 1 .526 3.596v-.001Z"
        fill="#E4FD69"
        opacity=".5" />

				<path
        d="M8.198 23.043h-.001l-.017-.001a8.084 8.084 0 0 1-.443-.023c.083.012.163.02.242.027h.01l.209-.003Z"
        fill="#FF425A" />

				<path
        d="M8.198 23.043h-.001l-.017-.001a8.084 8.084 0 0 1-.443-.023c.083.012.163.02.242.027h.01l.209-.003Z"
        fill="#FF425A" />

				<path
        d="m10.66 21.901-.001.003a2.702 2.702 0 0 1-.664.905 8.633 8.633 0 0 1-1.464.219c-.052.004-.103.005-.154.008l-.04.002-.044.001c-.032 0-.064.003-.096.004h-.042l-.167.003H7.93c-.051 0-.1 0-.15-.003h-.035a7.706 7.706 0 0 1-.435-.023c-.002.002-.004 0-.005 0a8.2 8.2 0 0 1-.874-.116c-.19-.173-.46-.45-.645-.756a1.759 1.759 0 0 1-.123-.238l-.003-.008c-.384-.841-.329-1.777.187-2.674.187-.324.411-.631.643-.927.617-.785 1.073-1.633 1.094-2.749.779.529 1.216 1.212 1.407 2.003.187.783.225 1.602.33 2.423.62-.313.777-.946.813-1.672a3.478 3.478 0 0 1 .526 3.596v-.001Z"
        fill="#E4FD69" />

			</g>
			<defs>
				<clipPath id="a">
					<path d="M0 0h15.84v23.046H0z" fill="#fff" />
				</clipPath>
			</defs>
		</svg>
	</div>;


const Diamond = () =>
<div className={clsx(styles.icon, styles.diamond)}>
		<svg fill="none" height="17" width="19" xmlns="http://www.w3.org/2000/svg">
			<path d="M6.866.833 5.31 5.617H0L3.697.833h3.169Z" fill="#fff" />
			<path d="M6.866.833 5.31 5.617H0L3.697.833h3.169Z" stroke="#fff" />
			<path d="M19 5.617h-5.31L12.133.833h3.156L19 5.617Z" fill="#fff" />
			<path d="M19 5.617h-5.31L12.133.833h3.156L19 5.617Z" stroke="#fff" />
			<path d="M9.5 16.666 0 5.617h5.31l4.19 11.05Z" fill="#fff" />
			<path d="M9.5 16.666 0 5.617h5.31l4.19 11.05Z" stroke="#fff" />
			<path d="m19 5.617-9.5 11.05 4.19-11.05H19Z" fill="#fff" />
			<path d="m19 5.617-9.5 11.05 4.19-11.05H19Z" stroke="#fff" />
			<path d="M13.69 5.617 9.5 16.667 5.312 5.616h8.379Z" fill="#fff" />
			<path d="M13.69 5.617 9.5 16.667 5.312 5.616h8.379Z" stroke="#fff" />
			<path d="M13.69 5.617H5.311L6.867.833h5.268l1.555 4.784Z" fill="#fff" />
			<path d="M13.69 5.617H5.311L6.867.833h5.268l1.555 4.784Z" stroke="#fff" />
			<g opacity=".1">
				<path d="M6.866.833 5.31 5.617H0L3.697.833h3.169Z" fill="#0DD" />
				<path d="M6.866.833 5.31 5.617H0L3.697.833h3.169Z" stroke="#fff" />
			</g>
			<path d="M19 5.617h-5.31L12.133.833h3.156L19 5.617Z" fill="#0DD" />
			<path d="M19 5.617h-5.31L12.133.833h3.156L19 5.617Z" stroke="#fff" />
			<g opacity=".4">
				<path d="M9.5 16.666 0 5.617h5.31l4.19 11.05Z" fill="#0DD" />
				<path d="M9.5 16.666 0 5.617h5.31l4.19 11.05Z" stroke="#fff" />
			</g>
			<path
      d="m19 5.617-9.5 11.05 4.19-11.05H19Z"
      fill="#0DD"
      fillOpacity=".9" />

			<path d="m19 5.617-9.5 11.05 4.19-11.05H19Z" stroke="#fff" />
			<g opacity=".7">
				<path d="M13.69 5.617 9.5 16.667 5.312 5.616h8.379Z" fill="#0DD" />
				<path d="M13.69 5.617 9.5 16.667 5.312 5.616h8.379Z" stroke="#fff" />
			</g>
			<g opacity=".4">
				<path d="M13.69 5.617H5.311L6.867.833h5.268l1.555 4.784Z" fill="#0DD" />
				<path
        d="M13.69 5.617H5.311L6.867.833h5.268l1.555 4.784Z"
        stroke="#fff" />

			</g>
		</svg>
	</div>;


export const BET_TYPE_LABELS: Record<
  string,
  ({ repub }: {repub: Repub;}) => ReactNode> =
{
  HOTTEST: ({ repub }) =>
  <span className={styles.betTypeLabel}>
			{repub === REPUBS.OC.name ? 'Hottest Bets' : 'Hottest Props'} <Hot />
		</span>,

  DIAMOND_IN_THE_ROUGH: () =>
  <span className={styles.betTypeLabel}>
			Diamonds in the Rough <Diamond />
		</span>

};